export const transformRequestPutRefundOnHold = ({ returnId, payload }) => {
  return {
    returnId,
    payload: {
      mode: payload.mode,
      delay_days: payload.delay_days,
      reason: payload.reason,
    },
  }
}
